import isNaN from "lodash/isNaN"
import get from "lodash/get"
import withSSRModel from "hoc-lib/ssrModelMapper"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import { getWindow } from "utils-lib/getWindow"
import {
  clearSelectedFacilityId,
  clearhoveredMapMarkerId,
  getMapLocations,
  selectFacility,
  setHasGeosuggestion,
  setSearchText,
  setCustomerAction,
  sethoveredMapMarkerId,
  updateGeosuggestLocation,
  translateFacility,
  setCustomerAddress,
} from "actions-lib"
import Map from "./Map"

const ssrWindow = getWindow()

export const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      clearSelectedFacilityId,
      clearhoveredMapMarkerId,
      getMapLocations,
      selectFacility,
      setHasGeosuggestion,
      setSearchText,
      setCustomerAction,
      sethoveredMapMarkerId,
      updateGeosuggestLocation,
      translateFacility,
      setCustomerAddress,
    },
    dispatch,
  ),
})

export const mapStateToProps = (state, ownProps) => {
  let defaultMapCenter = {}

  const lat = parseFloat(get(ownProps, `defaultMapCenter.lat`, ``))
  const lng = parseFloat(get(ownProps, `defaultMapCenter.lng`, ``))

  if (lat && lng && !isNaN(lat) && !isNaN(lng)) {
    if (
      ssrWindow.google &&
      ssrWindow.google.maps &&
      typeof ssrWindow.google.maps.LatLng === "function"
    ) {
      defaultMapCenter = new ssrWindow.google.maps.LatLng(lat, lng)
    }
  }

  return {
    customerSelections: state.customerSelections,
    facilityLocator: state.facilityLocator,
    siteAnalytics: state.siteAnalytics,
    siteLanguage: state.siteLanguage,
    userAccount: state.userAccount,
    defaultMapCenter,
  }
}

const WrappedComponent = withSSRModel(
  connect(mapStateToProps, mapDispatchToProps)(Map),
)

// Component has to be mapped by the consumer
// Config has to be imported from constants-lib and passed to the MapTo function by the consumer
export default WrappedComponent
